import { Stack, Typography, useTheme } from "@mui/material";
import { FiUser } from "react-icons/fi";

const TextWithIcon = ({ Icon = FiUser, text }) => {
  const theme = useTheme();
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Icon color={theme.palette.text.primary} />
      <Typography variant="body1" color={theme.palette.text.secondary}>
        {text}
      </Typography>
    </Stack>
  );
};

export default TextWithIcon;
